export const safeJSONParse = (input: string) => {
  try {
    const looksEncoded = /%[0-9A-Fa-f]{2}/.test(input)

    const decoded = looksEncoded ? decodeURIComponent(input) : input

    return JSON.parse(decoded)
  } catch (e) {
    return null
  }
}
